import { Flex, Icon, MenuItem, Text, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { RiWallet3Line } from "react-icons/ri";
import { SchoolFormId } from "../types";
import { RequestPaymentDialog } from "./RequestPaymentDialog";

interface RequestPaymentProps {
  selectedFormSchools: SchoolFormId[];
  onRefetch: () => void;
}

export const RequestPayment: React.FC<RequestPaymentProps> = ({
  selectedFormSchools,
  onRefetch,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(
    null
  );

  return (
    <>
      <MenuItem
        textColor="gray.700"
        fontWeight="400"
        fontSize="sm"
        onClick={onOpen}
        isDisabled={!selectedFormSchools.length}
      >
        <Flex gap={2} alignItems="center">
          <Icon as={RiWallet3Line} />
          <Text>Request payment</Text>
        </Flex>
      </MenuItem>

      <RequestPaymentDialog
        selectedFormSchools={selectedFormSchools}
        isOpen={isOpen}
        onCancel={onClose}
        selectedTemplateId={selectedTemplateId}
        onTemplateChange={setSelectedTemplateId}
        onRefetch={onRefetch}
      />
    </>
  );
};
